module.exports = __webpack_public_path__ + "static/media/Правила за работа на ОК (Проект).58d31c3c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Правила за работа на ОК (Проект).pdf
// module id = 117
// module chunks = 0